var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-bidding-all",attrs:{"id":"ItemBidding"}},[_c('v-card',{staticClass:"mt-4",attrs:{"outlined":""}},[_c('v-card-title',[_vm._v("Item Bidding ")]),_c('v-card-text',[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.dataProjectTemplate}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }